import service from '@/http/HttpInterceptor.js'
import API_LIST from '@/api/config'
import store from '@/store'
import AMap from 'AMap'
/**
 * 获取所有life
 */
export const getAllLife = (params) => {
  return service({
    url: API_LIST.common.life,
    method: 'get',
    params: params
  })
}
/**
 * 获取当前位置--经纬度--城市名称
 *
 */
export const getMapData = (callback) => {
  if (store.state.app.cityName !== null) {
    callback()
    return
  }
  const map = new AMap.CitySearch()
  map.getLocalCity((status, result) => {
    if (status === 'complete' && result.info === 'OK') {
      if (result && result.city && result.bounds) {
        store.commit('SET_MAPDATA', result)
        callback(result)
      }
    }
  })
}
/**
 * 更新阅读数-分享数
 * @params {*} contentId
 */
export const updateNum = (params) => {
  return service({
    url: API_LIST.common.updateSubtanceNum,
    method: 'post',
    params: params
  })
}
/**
 * 更新点赞数
 * @params {*} contentId
 */
export const updatePraiseNum = (params) => {
  return service({
    url: API_LIST.common.updateSubtancePraiseNum,
    method: 'post',
    params: params
  })
}
/**
 * 录入访客信息
 * @params {*} isApp
 * @params {*} visitTitle
 * @params {*} visitorCity
 * @params {*} visitorLatitude
 * @params {*} visitorLongitude
 */
export const insertVistor = (params) => {
  return service({
    url: API_LIST.visit.insert,
    method: 'get',
    params: params
  })
}
/**
 * 获取分类结构树
 * @params {*} menusId
 */
export const getClassifyTree = (params) => {
  return service({
    url: API_LIST.common.classifyTree,
    method: 'get',
    params: params
  })
}
/**
 * 发表评论
 * @params {*}
 */
export const addComment = (params) => {
  return service({
    url: API_LIST.common.addComment,
    method: 'post',
    data: params
  })
}
/**
 * 获取评论列表
 * @params {*} substanceId
 */
export const getCommentList = (params) => {
  return service({
    url: API_LIST.common.commentList,
    method: 'get',
    params: params
  })
}
/**
 * 获取登录的验证码图片
 * @params {*} substanceId
 */
export const getLoginPic = (params) => {
  return service({
    url: API_LIST.common.loginPic,
    method: 'get',
    params: params
  })
}
/**
 * 校对验证码
 * @params {*} code
 */
export const checkLoginPic = (params) => {
  return service({
    url: API_LIST.common.checkPic,
    method: 'get',
    params: params
  })
}
/**
 * 校对手机验证码
 * @params {*} code
 */
export const checkLoginCode = (params) => {
  return service({
    url: API_LIST.common.checkCode,
    method: 'get',
    params: params
  })
}
/**
 * 获取轮播
 * @params {*} code
 */
export const getCarousel = (params) => {
  return service({
    url: API_LIST.common.carousel,
    method: 'get',
    params: params
  })
}

/**
 * 获取首页数据
 *
 */
export const ConfigsOne = (params) => {
  return service({
    url: API_LIST.common.indexData,
    method: 'get',
    params: params
  })
}

/**
 * 获取首页非遗数据
 *
 */
export const getIndexHeritorData = () => {
  return service({
    url: API_LIST.common.indexHeritorData,
    method: 'get'
  })
}

/**
 * 获取首页场馆数据
 *
 */
export const getIndexVenueData = () => {
  return service({
    url: API_LIST.common.indexVenueData,
    method: 'get'
  })
}

/**
 * 获取首页非遗列表
 *
 */
export const getIndexHeritorList = (params) => {
  return service({
    url: API_LIST.common.indexHeritorList,
    method: 'get',
    params: params
  })
}
/**
 * 第三方登录
 * @params {*} userType
 * @params {*} preurl 前一个页面url()绑定手机页面url()错误页面url()，几个页面路径拼接而成，品接符()
 */
export const thirdLogin = (params) => {
  return service({
    url: API_LIST.common.thirdLogin,
    method: 'get',
    params: params
  })
}
/**
 * 获取用户行为
 * @params {*} substanceId
 */
export const getUserBehavior = (params) => {
  return service({
    url: API_LIST.common.behavior,
    method: 'get',
    params: params
  })
}

/**
 * 绑定手机号-新增
 * @params {*} mobile
 * @params {*} nickname
 * @params {*} cover
 * @params {*} gender
 * @params {*} pwd
 * @params {*} lcCode
 * @params {*} wxid
 * @params {*} qqId
 * @params {*} wbId
 */
export const bindMobile = (params) => {
  return service({
    url: API_LIST.common.bindMobile,
    method: 'post',
    data: params
  })
}
/**
 * 绑定手机号-更新
 * @params {*} id
 * @params {*} wxid
 * @params {*} qqId
 * @params {*} wbId
 */
export const bindMobileUpdate = (params) => {
  return service({
    url: API_LIST.common.updateMobile,
    method: 'post',
    data: params
  })
}

/**
 * 全局搜索
 * @params {*} title
 * @params {*} menusId
 */
export const searchKey = (params) => {
  return service({
    url: API_LIST.common.search,
    method: 'get',
    params: params
  })
}
/**
 * 获取省份
 */
export const getProvinceList = () => {
  return service({
    url: API_LIST.common.province,
    method: 'get'
  })
}
/**
 * 获取城市或者乡村
 * @params {*} params.regionCode // 父级地区code
 */
export const getCityOrCountryList = (params) => {
  return service({
    url: API_LIST.common.cityOrCountry,
    method: 'get',
    params: params
  })
}
/**
 * 获取签名
 */
export const getSignature = () => {
  return service({
    url: API_LIST.common.getSignature,
    method: 'post'
  })
}

/**
 * 获取文化地图数据
 * @params {*} title
 */
export const getCultureMapData = (params) => {
  return service({
    url: API_LIST.common.map,
    method: 'get',
    params: params
  })
}

/**
 * 获取关于我们
 */
export const getHelp = (params) => {
  return service({
    url: API_LIST.help.config,
    method: 'get',
    params: params
  })
}
/**
 * 获取标准规范
 */
export const getStandard = (params) => {
  return service({
    url: API_LIST.help.standard,
    method: 'get',
    params: params
  })
}
/**
 * 获取系统时间
 */
export const getSysTime = (params) => {
  return service({
    url: API_LIST.common.sysTime,
    method: 'get',
    params: params
  })
}
/**
 * 获取前端菜单
 */
export const getMenuFront = (params) => {
  return service({
    url: API_LIST.common.menuTree,
    method: 'get',
    params: params
  })
}

/**
 * 获取父级菜单
 * @params {*} id
 */
export const getParentMenuFront = (params) => {
  return service({
    url: API_LIST.common.parentMenu,
    method: 'get',
    params: params
  })
}

/**
 * 获取所有职业
 */
export const getProfessionList = (params) => {
  return service({
    url: API_LIST.common.getProfessionList,
    method: 'get',
    params: params
  })
}

/**
 * 获取当前生活圈下面的子生活圈
 * @params {*} parentCode
 * @params {*} status 1
 */
export const getLifeCircle = (params) => {
  return service({
    url: API_LIST.common.lifeCircle,
    method: 'get',
    params: params
  })
}
/**
 * 获取资源分类
 * @params {*} substanceId
 */
export const getResTypeList = (params) => {
  return service({
    url: API_LIST.common.resType,
    method: 'get',
    params: params
  })
}

/**
 * 获取专题详情
 **/
export const getTopicDetail = (params) => {
  return service({
    url: API_LIST.topic.one,
    method: 'get',
    params: params
  })
}

/**
 * 获取期刊栏目
 **/
export const getMColumn = (params) => {
  return service({
    url: API_LIST.magazine.column,
    method: 'post',
    data: params
  })
}
/**
 * 获取期刊列表
 **/
export const getMagazineList = (params) => {
  return service({
    url: API_LIST.magazine.list,
    method: 'post',
    data: params
  })
}
/**
 * 意见反馈
 **/
export const getfeedback = (params) => {
  return service({
    url: API_LIST.common.feedback,
    method: 'post',
    data: params
  })
}

/**
 * 获取文化地图数据
 **/
export const getAllMapData = () => {
  return service({
    url: API_LIST.map.list,
    method: 'get'
  })
}

/**
 * 根据地址获取活动
 **/
export const getActDataByAddress = (params) => {
  return service({
    url: API_LIST.map.one,
    method: 'get',
    params: params
  })
}
/**
 * 根据专题活动
 * parentCode
 **/
export const getSubJectList = (params) => {
  return service({
    url: API_LIST.common.subjectList,
    method: 'get',
    params: params
  })
}

/**
 * 根据专题活动
 * parentCode
 **/
 export const getSubJect = (params) => {
  return service({
    url: API_LIST.common.subject,
    method: 'get',
    params: params
  })
}
/**
 * 错误收集
 * @params
 */
export const insertError = (params) => {
  return service({
    url: API_LIST.error.add,
    method: 'post',
    data: params
  })
}
/**
 * 获取菜单
 */
export const getMenusList = (params) => {
  return service({
    url: API_LIST.common.menuslist,
    method: 'get',
    params: params
  })
}

/**
 * 获取菜单
 */
 export const getMenus = (params) => {
  return service({
    url: API_LIST.common.menus,
    method: 'get',
    params: params
  })
}
/**
 * 获取分类
 */
export const getClassifyList = (params) => {
  return service({
    url: API_LIST.common.classifyList,
    method: 'get',
    params: params
  })
}

/**
 * 获取分类
 */
 export const getResClassifyList = (params) => {
  return service({
    url: API_LIST.common.resClassList,
    method: 'get',
    params: params
  })
}


export default Object.assign({
  getAllLife,
  getMapData,
  updateNum,
  updatePraiseNum,
  insertVistor,
  getClassifyTree,
  addComment,
  getCommentList,
  getLoginPic,
  checkLoginPic,
  checkLoginCode,
  getCarousel,
  ConfigsOne,
  getIndexHeritorData,
  getIndexVenueData,
  getIndexHeritorList,
  thirdLogin,
  getUserBehavior,
  bindMobile,
  bindMobileUpdate,
  searchKey,
  getProvinceList,
  getCityOrCountryList,
  getSignature,
  getCultureMapData,
  getHelp,
  getStandard,
  getSysTime,
  getMenuFront,
  getParentMenuFront,
  getProfessionList,
  getLifeCircle,
  getResTypeList,
  getTopicDetail,
  getMColumn,
  getMagazineList,
  getAllMapData,
  getActDataByAddress,
  getSubJectList,
  getfeedback,
  insertError,
  getMenusList,
  getMenus,
  getSubJect,
  getClassifyList,
  getResClassifyList

})



// WEBPACK FOOTER //
// ./src/api/interface/interface-list/common.js